<template>
  <div class="content">
    <div class="image-text_1 flex-row justify-between">
      <div class="box_8 flex-col"></div>
      <span class="text-group_1">光辉历程</span>
      <div class="group_2 flex-col"></div>
    </div>
    <div class="time-line">
      <div class="snap-list">
        <el-timeline>
          <el-timeline-item v-for="(activity, index) in activities" :key="index"
              :class="index % 2 != 0? 'el-timeline-item-live-even':'el-timeline-item-live-out'">
            <!--  :class="index % 2 != 0? 'el-timeline-item-live-even':'el-timeline-item-live-out'" 这里做奇数偶数判断分辨修改样式 -->
            <div :class="index % 2 != 0? 'timeline-icon-y':'timeline-icon-z'"></div>
            <el-card shadow="hover" :class="index % 2 != 0?'el-card-left':'el-card-right'">
              <h4 class="title">{{activity.about_name}}</h4>
              <div v-html="activity.about_content" class="actContent"></div>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GloriousHistory",
  data() {
    return {
      activities: [
      ]
    }
  },
  methods:{
    //获取光辉历程列表
    getData() {
      var _this = this;
      _this.$api.post(
          "/Client/getGloriousHistory",
          {pageSize:1000,pageIndex:1},
          function (res) {
            if (res.code == "200") {
              _this.activities = res.data;
            }
          }
      );
    }
  },
  mounted() {
    let that = this;
    that.getData();
  },
}
</script>

<style scoped>
.content{
  width: 1120px;
}
.time-line{
  position: relative;top: 100px;
  min-height: 500px;
}
.el-card-left{
  margin-left: 40px;
}
.el-card-right{
  width: 470px;
}
.title{
  font-size: 18px;
}
.actContent{
  font-size: 14px;
}
.image-text_1 {
  width: 141px;
  height: 48px;
  position: relative;
  top: 88px;
}
.text-group_1 {
  width: 104px;
  height: 26px;
  overflow-wrap: break-word;
  color: rgba(30, 30, 30, 1);
  font-size: 26px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  line-height: 26px;
  margin-top: 11px;
}
.group_2 {
  width: 28px;
  height: 48px;
  background: url('../../../../assets/aboutSailHero/img/y_1.png')
  0px 0px no-repeat;
  background-size: 29px 48px;
}

.box_8 {
  width: 28px;
  height: 48px;
  background: url('../../../../assets/aboutSailHero/img/z_1.png')
  0px 0px no-repeat;
  background-size: 29px 48px;
  margin-left: 485px;
}
</style>

<style  lang="less" scoped>
/deep/ .snap-list {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  position: relative;
  left: -50px;
  .line {
    border-bottom: 1px solid rgb(36, 155, 255);
    width: 595px;
    position: absolute;
    top: 18px;
  }
  .el-timeline {
    margin-left: 650px;
    width: 595px;
    padding-left: 0px;
  }
  .timeline-icon-z {
    background: url('../../../../assets/aboutSailHero/img/z.png') no-repeat;
    background-size: 75px 18px;
    /* 设置图标的宽度和高度 */
    width: 75px;
    height: 18px;
    position: absolute;
    right: 0;
    top: 53px;
    /* 设置图标的位置 */
    background-position: center;
    /* 隐藏默认的图标 */
    background-color: transparent;
    border: none;
  }
  .timeline-icon-y {
    background: url('../../../../assets/aboutSailHero/img/y.png') no-repeat;
    background-size: 75px 18px;
    /* 设置图标的宽度和高度 */
    width: 75px;
    height: 18px;
    position: absolute;
    left: 0px;
    top: 48px;
    /* 设置图标的位置 */
    background-position: center;
    /* 隐藏默认的图标 */
    background-color: transparent;
    border: none;
  }
  .el-timeline-item {
    padding-bottom: 10px;
    .el-timeline-item__node--normal{
      display: none;
      margin-top: 45px;
    }
    .el-timeline-item__wrapper{
      padding-left: 43px;
      .el-timeline-item__content {
        color: #076EF1;
        font-size: 20px;
      }
      .el-timeline-item__timestamp {
        width: 550px;
        margin-top: 12px;
      }
      .el-timeline-item__timestamp.is-top{
        margin-bottom: -4px;
      }
    }
    .el-timeline-item__tail {
      border-left: 1px solid #005AD6;
      left: 0px;
      margin-top: 10px;
      height: 120%;
    }
    .el-timeline-item__node--large {
      width:14px;
      height: 14px;
      margin-top: 6px;
    }
  }
}
/deep/ .el-timeline-item-live-out{
  .el-timeline-item__wrapper{
    left: -595px;
  }
}
/deep/ .el-timeline-item-live-even{
  .el-timeline-item__wrapper{
    text-align: left;
  }
}
/deep/ .el-card{
  border: 0px solid #EBEEF5;
}
</style>
